module.exports = __webpack_public_path__ + "media/images/faces/face3-03d2735abfd0999445e297e3960aade9.jpg";